export const validateExternalIdRequiresArn = (assumeRoleArn, externalId) => {
  const hasExternalId = externalId && externalId.trim().length > 0;
  const hasAssumeRoleArn = assumeRoleArn && assumeRoleArn.trim().length > 0;
  if (hasExternalId && !hasAssumeRoleArn) {
    return "External ID can only be used when an Assume Role ARN is provided.";
  }
  return void 0;
};
export default {
  validateExternalIdRequiresArn
};
